module.exports = __webpack_public_path__ + "static/media/calendar.b7be529a.svg";